import React from 'react';

import { isMobileMedia } from 'bento-ordering/utils/media';
import CartContainer from 'bento-ordering/cart/containers/CartContainer';
import MenuContainer from 'bento-ordering/menus/containers/MenuContainer';
import withGoogleLibraryLoaded from 'bento-ordering/base/hoc/withGoogleLibraryLoaded';

/* THIS SHOULD ONLY FIRES ON DIRECT HIT TO /CART */
class CartRouteContainer extends React.Component {
  render() {
    if (isMobileMedia()) {
      return <CartContainer />;
    }
    return <MenuContainer shouldOpenCart />;
  }
}

export default withGoogleLibraryLoaded(CartRouteContainer);
